module.exports = __webpack_public_path__ + "static/media/notification.58147bb0.gif";